import { z } from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import { IndexationType, NoticePeriod } from "__generated__/graphql";

export type ContractOptionFormInput = z.input<typeof ContractOptionValidationSchema>;

export const ContractOptionValidationSchema = z.object({
	id: z.number().nullable(),
	contractId: z.number().optional(),
	validityWindow: ZodSchema.requiredField(z.object({
		from: ZodSchema.optionalNumber(),
		to: ZodSchema.optionalNumber(),
	})),
	description: z.string().max(50),
	indexationType: z.enum(IndexationType),
	indexationDate: ZodSchema.requiredField(z.number()),
	indexationAmount: ZodSchema.requiredField(z.number().min(0)),
	pricePerUnit: ZodSchema.requiredField(z.number().min(0)),
	noticePeriod: z.enum(NoticePeriod).optional(),
	optionTaken: z.boolean().nullable(),
	useEndPriceOfTheContract: z.boolean(),
});
